import { render } from "./QuizResultsPage.vue?vue&type=template&id=6b228abe&scoped=true"
import script from "./QuizResultsPage.vue?vue&type=script&lang=js"
export * from "./QuizResultsPage.vue?vue&type=script&lang=js"

import "./QuizResultsPage.vue?vue&type=style&index=0&id=6b228abe&lang=scss&scoped=true"

import exportComponent from "D:\\Development\\Illyrian\\witsrhi-journeytool-myprep\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b228abe"]])

export default __exports__